import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { NO_COMMON_HEADERS } from '@via/models';
import { Observable } from 'rxjs';

@Injectable()
export class CommonHeadersInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.context.get(NO_COMMON_HEADERS)) {
      return next.handle(req);
    }

    let reqCopy = req.clone();

    reqCopy = reqCopy.clone({
      setHeaders: {
        Authorization: `ApiKey 4D70566F7665456D5535714D416D564F-b3c1b09f-a255-4c8c-9437-141d9bbca5af`,
      },
    });

    return next.handle(reqCopy);
  }
}
